// custom PropType validator function for equiavlent of
// PropTypes.oneOfType([PropTypes.bool, null])
const nullOrBool = (props, propName, componentName) => {
  const propValue = props[propName];
  if (propValue === null) return;
  if (typeof propValue === 'boolean') return;
  return new Error(`${componentName} -> ${propName} : must be null or boolean`);
};

export default nullOrBool;
